import React from "react";
import SweetsCardList from "../components/SweetsCardList";

const Sweets = () => {
  return <SweetsCardList />;
};

export default Sweets;
